import React from "react";
import styled from "styled-components";

function index({ data }: any) {
  return <StkRow>{data.map((d: IProjectStack) => d.name).join(", ")}</StkRow>;
}

export default index;

const StkRow = styled.div`
  display: flex;
  padding: 24px 0 0;
  color: var(--purple-dark);
`;
